import ProductItemAdap from "./product-item-adap";

export default ProductItemAdap;